class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.addEventListener('pointerdown', this.onPointerDown.bind(this));
  }

  onPointerDown() {
    // A click that starts inside the menu (e.g. a Swiper slide navigated to
    // via the prev/next arrows) can fail to move focus onto the clicked link
    // because Swiper briefly marks slides `aria-hidden` during its loop/
    // transition handling, which blocks the browser from focusing anything
    // inside them. That sends focus to <body> instead, which onFocusOut
    // would otherwise mistake for a click outside the menu and close it.
    this._recentPointerDown = true;
    clearTimeout(this._pointerDownTimeout);
    this._pointerDownTimeout = setTimeout(() => {
      this._recentPointerDown = false;
    }, 350);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this._recentPointerDown) return;
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
